export function getMemberStatus(member) {
  return member?.member_status ?? member?.status ?? 'pending';
}

export function isRemovedLicenseMember(member) {
  if (!member) return true;
  if (member.removed_at != null && member.removed_at !== '') return true;
  return getMemberStatus(member) === 'removed';
}

export function isActiveLicenseSeat(member) {
  return !isRemovedLicenseMember(member);
}

/** Matches backend count_active_seats (owner + active members). */
export function countActiveLicenseSeats(members = []) {
  return members.filter(isActiveLicenseSeat).length;
}

export function getSharedMembersForDisplay(members = []) {
  return members.filter((member) => member.role !== 'owner');
}

/** Non-owner members that still occupy a shared seat. */
export function countActiveSharedMembers(members = []) {
  return members.filter(
    (member) => member.role !== 'owner' && isActiveLicenseSeat(member)
  ).length;
}

export function canAddSharedLicenseMember(license) {
  if (!license?.is_shared || !Array.isArray(license.members)) return false;
  const maxMembers = Number(license.max_members) || 0;
  return countActiveLicenseSeats(license.members) < maxMembers;
}
